<script>
import { Pie } from 'vue-chartjs'
export default {
    name: 'billstopaybymonth',
    extends: Pie,
    props: {
        period: {
            type: Number,
            default: 0
        }
    },
    computed: {
        getToken(){
            return this.$store.getters.getToken
        }
    },
    data(){
        return {
            data: [],
            values: [],
            chartdata: {
                labels: [],
                datasets: []
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    position: 'bottom',
                    fullWidth: false,
                }
            }
        }
    },
    methods: {
        updateData: function(){
            fetch(server + 'getbillstopaypermonth/period='+this.period, {
                method: 'GET',
                headers: new Headers({
                    'token' : this.getToken
                })
            })
                .then(response => (response.json()))
                .then(responseJSON => {
                    let data = responseJSON.data
                    let labels = []
                    let values = []
                    let colors = []

                    this.chartdata.labels = []
                    this.chartdata.datasets = []

                    for (let index = 0; index < data.length; index++) {
                        const element = data[index]

                        labels.push(element.DESCRICAO)
                        values.push(element.VALOR)
                        colors.push(this.getRandomColor())
                    }

                    this.chartdata.labels = labels
                    this.chartdata.datasets.push({
                        label: 'Valor',
                        backgroundColor: colors,
                        data: values
                    })

                    this.renderChart(this.chartdata, this.options)
                })
                .catch(error => (console.log(error)));
        },
        getRandomColor: function(){
            let letters = '0123456789ABCDEF'
            let color = '#'

            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)]
            }

            return color
        }
    },
    mounted () {
        this.updateData()
    },
    watch: {
        period: function(newVal, oldVal) {
            this.updateData()
        }
    }
}
</script>
<style scoped>

</style>